import Main3TCWrapper from "../../components/live3/tc/Main3TCWrapper";
import { config3 } from "../../constant/initDrawing";


const config = {
    ...config3,
    type: "tn",
    hlBG: "#A6ED8E",
    row_0: "#1B5A7A",
}

const Live3TCPage = () => {
    return <Main3TCWrapper config={config} />
}

export default Live3TCPage;